import { styled } from '@mui/material';

export const FooterButtons = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
